import { UsageInsightsDashboard } from 'src/features/usage-insights/usage-insights-dashboard';

const UsageInsightsTab = () => (
  <UsageInsightsDashboard />
);

export default UsageInsightsTab;
